export enum TypeFilterEnum {
  RANGE = 'Range',
  SINGLE = 'Single',
}
